export default {
  top: '/interview_application',
};
